import { PieChart, Pie, Cell } from "recharts";
import { getDietColor, getDietLabel } from "./normalize";

export function DietDonut({ score, category, animate }) {
  const pct = Math.round((score / 40) * 100);
  const color = getDietColor(category);
  const label = getDietLabel(category);
  const displayScore = animate ? score : 0;

  const chartData = [
    { value: displayScore },
    { value: 40 - displayScore },
  ];

  return (
    <div className="flex flex-col items-center" data-testid="diet-donut">
      <div style={{ width: 160, height: 160, position: "relative" }}>
          <PieChart width={160} height={160}>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={70}
              startAngle={90}
              endAngle={-270}
              dataKey="value"
              isAnimationActive={true}
              animationBegin={100}
              animationDuration={1000}
              animationEasing="ease-out"
              stroke="none"
            >
              <Cell fill={color} />
              <Cell fill="#E2D9CB" />
            </Pie>
          </PieChart>
        {/* Center text */}
        <div style={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center", pointerEvents: "none",
        }}>
          <div style={{ fontSize: 32, fontWeight: 800, color: "#2D2A24", lineHeight: 1 }}>
            {score}
          </div>
          <div style={{ fontSize: 14, color: "#71644C", lineHeight: 1, marginTop: 2 }}>
            /40
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, color, marginTop: 4, lineHeight: 1 }}>
            {label}
          </div>
        </div>
      </div>
    </div>
  );
}
